var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03057 5.46976L4.03055 5.46975C3.96088 5.40008 3.87817 5.34482 3.78715 5.30711C3.69612 5.26941 3.59855 5.25 3.50003 5.25C3.4015 5.25 3.30394 5.26941 3.21291 5.30711C3.12188 5.34482 3.03917 5.40008 2.9695 5.46975C2.89983 5.53942 2.84457 5.62213 2.80686 5.71316C2.76916 5.80419 2.74975 5.90175 2.74975 6.00028C2.74975 6.09881 2.76916 6.19637 2.80686 6.2874C2.84457 6.37842 2.89983 6.46113 2.9695 6.5308L7.9694 11.5307C7.96943 11.5307 7.96947 11.5308 7.9695 11.5308C8.03913 11.6005 8.12182 11.6558 8.21282 11.6935C8.30387 11.7312 8.40147 11.7507 8.50003 11.7507C8.59859 11.7507 8.69618 11.7312 8.78723 11.6935C8.87824 11.6558 8.96092 11.6005 9.03055 11.5308C9.03059 11.5308 9.03062 11.5307 9.03065 11.5307L14.0306 6.5308C14.1713 6.3901 14.2503 6.19926 14.2503 6.00028C14.2503 5.80129 14.1713 5.61046 14.0306 5.46975C13.8898 5.32905 13.699 5.25 13.5 5.25C13.301 5.25 13.1102 5.32905 12.9695 5.46975L12.9695 5.46976L8.50003 9.93983L4.03057 5.46976Z",
    fill: "#FF7A2A",
    stroke: "#FF7A2A",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownOrange);
export default __webpack_public_path__ + "static/media/ArrowDownOrange.3a4617f1cd8fbc38579d789024fa1044.svg";
export { ForwardRef as ReactComponent };